import { Pagination } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import { Link } from "react-router-dom";
import { formatDateFunction, getTabFromOrderStatus } from "../../../../utils/helper/utils";

const RefundOrdersReports = ({ inputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [totalRows, setTotalRows] = useState(0);

  const getAllReportsByRefundOrder = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };

      let response = await globalRequest(
        Apis.MANAGE_REPORT.GET_ALL_REFUND_ORDERS,
        "get",
        {},
        { params },
        true
      );

      let apiResponse = response?.data;
      if (response?.status === 200 && apiResponse?.status === "SUCCESS") {
        const refundData = apiResponse?.data?.data || [];
        const paginator = apiResponse?.data?.paginator || {};

        const formattedData = refundData.map((item, index) => {
          const order = item?.orderDetails || {};
          const user = order?.userDetails || {};
          const price = order?.priceDetails || {};

          return {
            id: item?.id,
            orderNumber: order?.orderNumber || "N/A",
            status: order?.status,
            refundId: item?.refundId || "N/A",
            customer: `${user?.firstName || ""} ${user?.lastName || ""} | ${user?.mobileNo || ""}`,
            subTotal: price?.sub_total || 0,
            couponDiscount: price?.coupon_discount || 0,
            dropZoneDiscount: price?.pickup_discount || 0,
            tax: price?.vat || 0,
            deliveryFees: price?.delivery_fees || 0,
            totalAmount: price?.total_amount || 0,
            refundAmount: item?.refundAmount || 0,
            refundStatus: item?.refundStatus || "N/A",
            refundReason: item?.refundReason || "N/A",
            orderStatus: order?.status || "N/A",
            refundMode:
              item?.refundMode === "credit_card"
                ? "Credit Card"
                : item?.refundMode === "apple_pay"
                ? "Apple Pay"
                : item?.refundMode || "N/A",
            deliveryDate: order?.deliveryDate || "N/A",
            refundDate:
              formatDateFunction(item?.createdAt, "yyyy-mm-dd", true) || "N/A",
          };
        });

        setList(formattedData);
        setTotalRows(paginator?.itemCount || 0);
      } else {
        toast.error(apiResponse?.message || "Failed to fetch data");
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByRefundOrder();
  }, [inputData, paginationModel]);

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full text-left text-sm text-gray-500">
          <thead className="text-gray-700 capitalize text-xs bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">ID</th>
              <th className="px-3 py-3 whitespace-nowrap">Order Number</th>
              <th className="px-3 py-3 whitespace-nowrap">Refund ID</th>
              <th className="px-3 py-3 whitespace-nowrap">Customer Information</th>
              <th className="px-3 py-3 whitespace-nowrap">SubTotal</th>
              <th className="px-3 py-3 whitespace-nowrap">Coupon Discount</th>
              <th className="px-3 py-3 whitespace-nowrap">Dropzone Discount</th>
              <th className="px-3 py-3 whitespace-nowrap">Tax</th>
              <th className="px-3 py-3 whitespace-nowrap">Delivery Charges</th>
              <th className="px-3 py-3 whitespace-nowrap">Grand Total</th>
              <th className="px-3 py-3 whitespace-nowrap">Refund Amount</th>
              <th className="px-3 py-3 whitespace-nowrap">Refund Status</th>
              <th className="px-3 py-3 whitespace-nowrap">Refund Reason</th>
              <th className="px-3 py-3 whitespace-nowrap">Order Status</th>
              <th className="px-3 py-3 whitespace-nowrap">Refund Payment Mode</th>
              <th className="px-3 py-3 whitespace-nowrap">Delivery Date</th>
              <th className="px-3 py-3 whitespace-nowrap">Refund Date</th>
            </tr>
          </thead>

          <tbody>
            {list && list.length > 0 ? (
              list.map((item) => (
                <tr key={item.id} className="bg-white border-b">
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <Link
                      className="cursor-pointer"
                      to={`/order-management/?order_number=${item?.orderNumber}`}
                      state={{
                        orderNumber: item?.orderNumber,
                        activeTab: getTabFromOrderStatus(item?.status)
                      }}
                      style={{ color: "#37846B", fontWeight: 500 }}
                    >
                      {item?.orderNumber}
                    </Link>
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.refundId}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.customer}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.subTotal}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.couponDiscount}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.dropZoneDiscount}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.tax}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.deliveryFees}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.totalAmount}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.refundAmount}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.refundStatus}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.refundReason}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.orderStatus}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.refundMode}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.deliveryDate}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.refundDate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={16} className="text-center py-6">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {list?.length > 0 && (
        <div className="text-right mt-4">
          <Pagination
            defaultCurrent={1}
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger
            current={paginationModel?.page}
            pageSize={paginationModel?.limit}
            onChange={(page) => setPaginationModel((prev) => ({ ...prev, page }))}
            onShowSizeChange={(current, size) =>
              setPaginationModel((prev) => ({ ...prev, limit: size, page: 1 }))
            }
          />
        </div>
      )}
    </>
  );
};

export default RefundOrdersReports;